(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'Upload', 'Account', '$rootScope', 'ApiTokens'];

    function SettingsController(Principal, Auth, JhiLanguageService, $translate, Upload, Account, $rootScope, ApiTokens) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.notificacoes = ['DEPLOY_PRODUCAO'];

        vm.copied = false;
        vm.createToken = createToken;
        vm.createdToken = null;
        vm.loadTokens = loadTokens;
        vm.newTokenName = '';
        vm.revokeToken = revokeToken;
        vm.copyToken = copyToken;
        vm.tokenError = null;
        vm.tokenSuccess = null;
        vm.tokens = [];

        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                notificacoes: account.notificacoes
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);

            angular.forEach(account.filas, function (fila) {
                vm.notificacoes.push(fila);
            });


            Account.getImagem({}, function (data) {
                if (data.id) {
                    vm.picFile = Upload.dataUrltoBlob(data.imagemOriginal, 'Original');
                    vm.croppedDataUrl = data.imagemAjustada;
                }
            });
        });

        loadTokens();

        function save() {
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                Upload.dataUrl(vm.picFile, true).then(
                    function (original) {
                        if (original && vm.croppedDataUrl) {
                            Account.saveImagem({
                                imagemOriginal: original,
                                imagemAjustada: vm.croppedDataUrl
                            }, function (data) {
                                vm.imagemOginal = data.imagemOriginal;
                                vm.croppedDataUrl = data.imagemAjustada;
                                $rootScope.$broadcast('authenticationSuccess');
                            });
                        }
                    }
                );
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        function loadTokens() {
            vm.tokens = ApiTokens.getAll();
        }

        function createToken() {
            vm.tokenError = null;
            vm.tokenSuccess = null;
            vm.copied = false;
            vm.createdToken = null;

            ApiTokens.create({name: vm.newTokenName}, function (response) {
                vm.createdToken = response.token;
                vm.newTokenName = '';
                vm.tokenSuccess = 'CREATED';
                loadTokens();
            }, function () {
                vm.tokenSuccess = null;
                vm.tokenError = 'CREATE';
            });
        }

        function revokeToken(id) {
            ApiTokens.delete({id: id}, function () {
                vm.tokenError = null;
                vm.tokenSuccess = 'REVOKED';
                loadTokens();
            }, function () {
                vm.tokenSuccess = null;
                vm.tokenError = 'REVOKE';
            });
        }

        function copyToken() {
            var input = document.getElementById('created-api-token');
            if (!input) {
                return;
            }
            input.select();
            document.execCommand('copy');
            vm.copied = true;
        }
    }
})();
